export default __webpack_public_path__ + "static/media/double-spicy.0af9b8e9.svg";